import { atom } from 'jotai';

type MySociosStickySectionAtomType = {
	height: number;
};

export const mySociosStickySectionAtom = atom<MySociosStickySectionAtomType>({
	height: 0
});
